// extracted by mini-css-extract-plugin
export default {"notification":"_1a-FY","notification-wrapper":"_2pM1Q","notificationWrapper":"_2pM1Q","tooltip":"X42FP","new-tooltip":"_3o3r_","newTooltip":"_3o3r_"};